import { Action, AppDispatch, AppThunk } from '../../definitions/types';
import { APP_PATHS, getNextDestination } from '../../routes/route-helpers';
import { ROUTER_PUSH_ACTION } from './actions-consts';
import {
  AppState,
  shouldForwardToCheckout,
  shouldForwardToDolphinCms,
  shouldForwardToOnestop,
} from '../reducers';
import { forwardToCheckout } from './checkout';
import { forwardToDolphinCms } from './dolphin-cms';
import { acceptOnestopToSAndForward } from '../../experiments/Grw1410OnestopProductPicker/Grw1410Utils';

const pushAction = (path: string): Action<string> => ({
  type: ROUTER_PUSH_ACTION,
  payload: path,
});

export function changeViewTo(pathname: string): Action<string> {
  return pushAction(pathname);
}

export function changeViewToDomain(): Action<string> {
  return changeViewTo(APP_PATHS.DOMAIN);
}

export function changeViewToProduct(): Action<string> {
  return changeViewTo(APP_PATHS.PRODUCT);
}

export function changeViewToIndustry(): Action<string> {
  return changeViewTo(APP_PATHS.INDUSTRY);
}

export function changeViewToPricing(): Action<string> {
  return changeViewTo(APP_PATHS.PRICING);
}

export function changeViewToTemplate(): Action<string> {
  return changeViewTo(APP_PATHS.TEMPLATE);
}

export function navigate(
  currentPath: string,
  forwardToCheckoutAction: typeof forwardToCheckout = forwardToCheckout,
  forwardToCmsAction: typeof forwardToDolphinCms = forwardToDolphinCms,
  acceptOnestopToSAndForwardAction: typeof acceptOnestopToSAndForward = acceptOnestopToSAndForward // TODO cleanup GRW-1410
): AppThunk {
  return (dispatch: AppDispatch, getState: () => AppState) => {
    const state = getState();
    const nextDestination = getNextDestination(currentPath, state);

    if (shouldForwardToCheckout(state, nextDestination)) {
      return dispatch(forwardToCheckoutAction());
    }

    if (shouldForwardToDolphinCms(state, nextDestination)) {
      return dispatch(forwardToCmsAction());
    }

    // TODO cleanup GRW-1410
    if (shouldForwardToOnestop(state, nextDestination)) {
      return dispatch(acceptOnestopToSAndForwardAction());
    }

    return dispatch(changeViewTo(nextDestination));
  };
}
